"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../../store/amount/actions");
var AmountListener = (function () {
    function AmountListener() {
    }
    AmountListener.listen = function (store) {
        var amountElements = document.querySelectorAll('.ctrl-amount');
        Array.from(amountElements).forEach(function (element) {
            element.addEventListener('click', function () {
                Array.from(amountElements).forEach(function (element) {
                    if (element.classList.contains('active')) {
                        store.dispatch(actions_1.resetAmount());
                        element.classList.remove('active');
                    }
                });
                store.dispatch(actions_1.setAmount({
                    MoneyValue: Number(element.children[0].dataset.money),
                    Counter: Number(element.children[0].dataset.counter)
                }));
                element.classList.add('active');
            });
        });
    };
    return AmountListener;
}());
exports.default = AmountListener;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/listeners/betting/amount.ts
// module id = 2397
// module chunks = 5